import React from "react";
import Menu1 from "./menu1/Menu1";
import Menu2 from "./menu2/Menu2";
import Menu3 from "./menu3/Menu3";
import Menu4 from "./menu4/Menu4";
import Menu5 from "./menu5/Menu5";
import Menu6 from "./menu6/Menu6";
import Menu7 from "./menu7/Menu7";
import Menu8 from "./menu8/Menu8";
import Menu9 from "./menu9/Menu9";
import Menu99 from "./menu99/Menu99";

function Menu(props) {
  return <li>{props.name}</li>;
}

function MenuDiv(props) {
  return (
    <>
      {props.id === "crm01" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu1 name={props.name} selected={props.selected}></Menu1>
        </div>
      ) : props.id === "crm02" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu2 name={props.name} selected={props.selected}></Menu2>
        </div>
      ) : props.id === "crm03" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu3 name={props.name} selected={props.selected}></Menu3>
        </div>
      ) : props.id === "crm04" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu4 name={props.name} selected={props.selected}></Menu4>
        </div>
      ) : props.id === "crm05" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu5 name={props.name} selected={props.selected}></Menu5>
        </div>
      ) : props.id === "crm06" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu6 name={props.name} selected={props.selected}></Menu6>
        </div>
      ) : props.id === "crm07" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu7 name={props.name} selected={props.selected}></Menu7>
        </div>
      ) : props.id === "crm08" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu8 name={props.name} selected={props.selected}></Menu8>
        </div>
      ) : props.id === "crm09" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu9 name={props.name} selected={props.selected}></Menu9>
        </div>
      ) : props.id === "crm99" ? (
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <Menu99 name={props.name} selected={props.selected}></Menu99>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export { Menu, MenuDiv };
